import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import CommonNavbar from "../CommonLayout/CommonNavbar";
import CommonFooter from "../CommonLayout/CommonFooter";

const Install = () => {
  const handleInstall = () => {
    // Redirect to the Zoom OAuth connect endpoint for counselorId 2
    window.location.href = "https://api.psychooncology.online/api/zoom/connect?counselorId=2";
  };

  return (
    <>
      <CommonNavbar />
      <Container className="py-5 text-center">
        <Row  style={{paddingBottom: "250px"}}>
          <Col>
            <h1>Integration with Zoom</h1>
            <p>
              Connect your Zoom account to our counselling appointment platform.
              With seamless Zoom integration, automatically generate meeting links for every booked session,
              manage your availability, and provide an efficient virtual consultation experience.
            </p>
            <Button variant="primary" size="lg" onClick={handleInstall}>
              Connect Zoom
            </Button>
          </Col>
        </Row>
      </Container>
      <CommonFooter />
    </>
  );
};

export default Install;
